import { forwardRef } from 'react'
import { Search } from 'lucide-react'
import { cn } from '@/lib/utils/cn'
import { Input, type InputProps } from '../Input'

export type SearchInputProps = Omit<InputProps, 'type'> & {
  containerClassName?: string
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { className, containerClassName, placeholder = 'Search', ...rest },
  ref,
) {
  return (
    <div className={cn('relative max-w-80', containerClassName)}>
      <Search
        aria-hidden="true"
        size={14}
        className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-tertiary"
      />
      <Input ref={ref} type="search" placeholder={placeholder} className={cn('pl-8', className)} {...rest} />
    </div>
  )
})
